// LoginOTP.js

import React, { useContext, useRef, useState } from 'react';
import apiClient from '../../api/apiClient';
import {useLocation, useNavigate } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const LoginOTP = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOtp] = useState('');
    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value;

        // Only allow numbers and restrict input length to 1
        if (value.match(/^[0-9]*$/) && value.length <= 1) {
            const newOtp = otp.split('');
            newOtp[index] = value;
            setOtp(newOtp.join(''));

            // Move focus to the next input field if current input is filled
            if (value.length === 1 && index < 5) {
                inputRefs.current[index + 1].focus(); // Move to next input
            }
        }
    };

    const handleKeyDown = (e, index) => {
        // Check if Backspace key is pressed
        if (e.key === 'Backspace' && !otp[index]) {
            // Move focus to the previous input field if current input is empty
            if (index > 0) {
                inputRefs.current[index - 1].focus(); // Move to previous input
            }
        }
    };

    // ************************************************************************************************************************************
    // const { login } = useContext(AuthContext);
  const navigate = useNavigate();
    const location = useLocation();
    const Mobiletoken = location.state?.token;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (otp.length < 6) {
            toast.error("password must be 6 digit");
            return; // Exit the function
        }

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': Mobiletoken
        };

        try {
            setIsSubmitting(true)

            const response = await apiClient.post(`/login/verifyOTP_resetpassword`, {
                otp: otp
            }, { headers });

            if (response.data.Status === "SUCCESS") {
                // console.log("SUCCESS OTP CORRECT")
                const token = response.data.data;
                toast.success(response.data.message);
                // console.log("SUCCESS OTP CORRECT token", token)
                navigate('/confirm_password', { state: { token: token } });
            }
            else {
                console.log("FAILED OTP INCORRECT")
                toast.error(response.data.message);
            }

        } catch (error) {
            console.error(" CATCH Error OTP:", error.response ? error.response.data : error.message);
            toast.error( error.response ? error.response.data.message : error.message);

        }
        finally{
            setIsSubmitting(false)
        }

    };


    return (
        <>
        <div className="col-xxl-3 col-lg-4 col-md-5">
            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                    <div className="d-flex flex-column h-100">
                        <div className="mb-4 mb-md-5 mt-4 text-center">
                            <a href="index.html" className="d-block auth-logo">
                                <img src="../assets/images/MMB_LOGO/MMB_LOGO.png" alt="img" height={32} />
                                <span className="logo-txt">MMB</span>
                            </a>
                        </div>
                        <div className="auth-content mt-5">
                            <div className="text-center">
                                <h4>Verify your Number</h4>
                                <p className="mb-5">
                                    Please enter the 6 digit code sent to{" "}
                                    <span className="fw-bold">❤️.com</span>
                                </p>
                                <form >
                                    <div className="otp-input-container">
                                        {Array.from({ length: 6 }).map((_, index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                className="otp-input"
                                                maxLength={1}
                                                ref={el => inputRefs.current[index] = el} // Assign ref to input
                                                value={otp[index] || ''} // Get specific digit
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)} // Handle key down for backspace
                                            />
                                        ))}
                                    </div>
                                    <button
                                        className="btn btn-primary w-100 waves-effect waves-light mt-4"
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={isSubmitting} // Disable button when isSubmitting is true
                                        >
                                            {isSubmitting ? 'Processing...' : 'Confirm'}
                                        
                                    </button>
                                </form>
                            </div>
                            <div className="mt-5 text-center">
                                {/* <p className="text-muted mb-0">
                                    Didn't receive an email?{" "}
                                    <a href="#" className="text-primary fw-semibold">Resend</a>
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default LoginOTP;
